import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { BasicScrollView } from "@/components/BasicScrollView";
import { Link, RelativePathString, useRouter } from 'expo-router';
import Head from 'expo-router/head';
import * as AppUtils from '@/utilities/AppUtils';
import { CustomText } from '@/components/CustomText';
import * as AppConstants from '@/utilities/AppConstants';
import { AppContext } from '@/components/AppContext';
import * as AppUtilities from "@/utilities/AppUtilities";
import Footer from '@/components/Footer';
import type { RootState } from '@/state/store';
import { useSelector, useDispatch } from 'react-redux';
import { AppText } from '@/components/AppText';
import { Pressable, StyleSheet, TextInput as RNTextInput, View } from 'react-native';
import { Button, Button as Button95, Hourglass, Panel, TextInput } from 'react95-native-rabbl';
import * as AppConsts from "@/utilities/AppConsts";
import { useForm, Controller } from "react-hook-form";
import { ExternalLink } from '@/components/ExternalLink';
import { Image } from 'expo-image';
import { Meta } from '@/components/Meta';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    alignItems: 'center',
    backgroundColor: 'transparent',
    gap: 20,
  },
  formElement: {
    maxWidth: 300,
  },
  contentWrapper: {
    padding: 20,
    gap: 20,
  },
  inputWrapper: {
    flexDirection: 'row',
  },
  appStoreImage2: {
    width: 200,
    height: 68,
  },
});

export default function JoinApple() {
  const isMainLogicalHost = useSelector((state: RootState) => state.user.isMainLogicalHost);

  /*const { showSpinner, hideSpinner } = useContext(AppContext);
  const emailInput = useRef<RNTextInput>(null);
  const reduxState = useSelector((state: RootState) => state);
  const router = useRouter();

  const { register, control, handleSubmit, setValue, reset, formState: { errors } } = useForm({
    defaultValues: {
      email: '',
    }
  });

  const onSubmit = useCallback(async (data: any) => {
    try {
      showSpinner();

      let formInput = {};

      (formInput as any)['action'] = "Unsubscribe";
      (formInput as any)['log'] = AppUtilities.getAccumulatedDebug();
      (formInput as any)['state'] = reduxState;

      await AppUtilities.fetchUnauthorized(
        "JoinApple.onSubmit",
        "/rabbl/api/applejoin",
        "POST",
        {
          email: data.email,
        }
      );

      router.navigate("/joinappleconfirm");

    } catch (e) {
      AppUtils.showErrorToast(AppUtilities.getErrors(e), () => onSubmit(data), true);
      AppUtilities.handleException(e, "JoinApple.onSubmit");
    } finally {
      hideSpinner();
    }
  }, [router, reduxState]);

  async function onValidationErrors(errors: any) {
    AppUtils.showErrorToast('There are some errors. Review and try again.');
  };

  useEffect(() => {
    if (AppUtilities.shouldAutoFocus()) {
      if (emailInput && emailInput.current) {
        emailInput.current?.focus();
      }
    }
  }, [emailInput]);*/

  return (
    <BasicScrollView center={true}>
      <Meta title={"Join on Apple devices"} />
      <Panel variant='raised' elevation={4}>
        <View style={AppConstants.STYLES.padding20gap20center}>
          <AppText>Our app is currently in beta on the Apple App store and you can install the beta using Apple TestFlight:</AppText>
          <ExternalLink href={AppConsts.APPLE_STORE_LINK} target='_blank' asChild={AppUtilities.isWeb()}>
            <Image source={require('@/assets/images/testflight200x68.png')} style={styles.appStoreImage2} />
          </ExternalLink>
          <View style={AppConstants.STYLES.padding1} />
          {
            isMainLogicalHost ?
                <>
                  <AppText>Alternatively, join on the web with a credit card:</AppText>
                  <Link href="/join" asChild={true} className="nontext"><Button>Join on the web</Button></Link>
                </>
              :
                <>
                  <AppText>Alternatively, join on the web of a particular Rabbl with a credit card:</AppText>
                  <View style={AppConstants.STYLES.flexRow}>
                    <Link href="/findrabbl" asChild className={"nontext"}><Button>Find a Rabbl</Button></Link>
                  </View>
                </>
          }
          {/*
          <Controller
            control={control}
            name="email"
            rules={{
              required: true,
            }}
            render={({ field: { onChange, onBlur, value } }) => (
              <TextInput
                ref={emailInput}
                value={value}
                onChangeText={onChange}
                placeholder="Your email"
                style={styles.formElement}
                returnKeyType="next"
                onBlur={onBlur}
                autoComplete="email"
                keyboardType="email-address"
                autoCapitalize='none'
                textContentType="emailAddress"
                onSubmitEditing={handleSubmit(onSubmit, onValidationErrors)}
              />
            )}
          />
          {errors.email && <AppText selectable={true} style={AppConstants.STYLES.fontBoldColorRed}>^^ Email is required.</AppText>}

          <View style={styles.inputWrapper}>
            <Button95 onPress={handleSubmit(onSubmit, onValidationErrors)}>Apply</Button95>
          </View>
          */}
        </View>
      </Panel>
      <Footer />
    </BasicScrollView>
  );
}
